import NotificationActions from 'client/js/main/actions/NotificationActions';
import dash_api from 'client/js/main/support/dash_api';
import { ReduxAsyncAction } from 'client/js/redux/services/ReduxAsyncAction';
import type { DataAction } from 'client/js/redux/types/dataAction.type';
import type { QrCodeSettings } from '../../../../../../shared/types';

type FetchQrCodeSettingsActionPayload = { qrCodeSettings: QrCodeSettings };

const API_VERSION: string = '/v1';
const API_ENDPOINT: string = '/qr-code/settings';
const NOTIFICATION_MESSAGE: string = 'Failed Fetching QR Code Settings';
const NOTIFICATION_STATUS: string = 'error';

const FETCH_QR_CODE_SETTINGS_NAMESPACE = 'FETCH_QR_CODE_SETTINGS' as const;

const FetchQrCodeSettings = new ReduxAsyncAction<
  typeof FETCH_QR_CODE_SETTINGS_NAMESPACE,
  void,
  FetchQrCodeSettingsActionPayload
>(FETCH_QR_CODE_SETTINGS_NAMESPACE);

FetchQrCodeSettings.registerRequest(async () => {
  try {
    const response = await dash_api.get(`${API_VERSION}${API_ENDPOINT}`);

    const data = response.data;

    return { qrCodeSettings: data };
  } catch (error) {
    NotificationActions.showNotification(NOTIFICATION_MESSAGE, NOTIFICATION_STATUS);

    throw error;
  }
});

export const FETCH_QR_CODE_SETTINGS = FetchQrCodeSettings.actionNamespaceConstants;

export const fetchQrCodeSettings = FetchQrCodeSettings.request;

export type FetchQrCodeSettingsResponseAction = DataAction<
  typeof FETCH_QR_CODE_SETTINGS.response,
  FetchQrCodeSettingsActionPayload
>;
